const linksConfig = {
  fullMediaScenariosDefinition: {
    isVisible: true,
    type: 'tooltip',
    tooltipText: 'Full Media Scenarios definition',
    ctaName: 'Learn more',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/Scenariusze?csf=1&web=1&e=679fot',
  },
  sociovisionSegmentsDefinition: {
    isVisible: true,
    type: 'tooltip',
    tooltipText: 'SocioVision segments definition',
    ctaName: 'Learn more',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/Segmenty%20SV?csf=1&web=1&e=MkVC8T',
  },
  seeGoldenRules: {
    isVisible: true,
    type: 'directLink',
    ctaName: 'See Golden Rules',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/Golden%20Rules?csf=1&web=1&e=8fBzcM',
  },
  howToUse: {
    isVisible: true,
    type: 'directLink',
    ctaName: 'How to use?',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/Training?csf=1&web=1&e=J1kja5',
  },
  partnerShareRecommendation: {
    isVisible: true,
    type: 'tooltip',
    tooltipText: 'Partner share recommendation',
    ctaName: 'Learn more',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/Partner%20Share%20Recomendation?csf=1&web=1&e=p36WSb',
  },
  checkCompetitorsWeights: {
    isVisible: true,
    type: 'directLink',
    ctaName: 'Check competitors weights',
    url: 'https://app.powerbi.com/groups/me/reports/28b6cfd7-6f51-47fc-b4b...8?ctid=86cbe1bb-213f-4271-b174-bd59d03c87a3&experience=power-bi',
  },
  checkTypesDefinitions: {
    isVisible: true,
    type: 'directLink',
    ctaName: 'Check types definitions',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/OOH?csf=1&web=1&e=7f3Jm0',
  },
  ddx1pAcquistion: {
    isVisible: true,
    type: 'tooltip',
    tooltipText: 'Check DDX 1P acquistion calculations',
    ctaName: 'DDX 1P acquistion',
    url: 'https://loreal.sharepoint.com/:f:/r/sites/-PL-WMxLOREAL/Documents%20partages/General/15.%20AXIS/DDX%201P%20acquisition?csf=1&web=1&e=KyC1J4',
  },
};

export default linksConfig;
